import * as React from 'react'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import Button from 'components/button'
import * as Context from '../contexts/root'
import styles from './styles.module.css'

export function ButtonSet({ children }) {
    return <div className={styles.ButtonSet}>{children}</div>
}

export function Previous({ as: As = Button, disabled, children }) {
    const send = Context.useService()[1]
    function previous() {
        send('PREVIOUS')
    }

    return (
        <As large chevron="LEFT" onClick={previous} disabled={disabled}>
            {children}
        </As>
    )
}

export function Next({ as: As = Button, children, onClick, disabled }) {
    const send = Context.useService()[1]
    function next() {
        send('NEXT')
    }

    return (
        <As large chevron="RIGHT" onClick={onClick || next} disabled={disabled}>
            {children}
        </As>
    )
}

export function StepSet() {
    return (
        <ol className={styles.StepSet}>
            <Step name="form">
                <FormattedMessage
                    defaultMessage="Form"
                    description={'Mountain Information Network - Form'}
                />
            </Step>
            <Step name="preview">
                <FormattedMessage
                    defaultMessage="Preview"
                    description={'Mountain Information Network - Form'}
                />
            </Step>
            <Step name="submit">
                <FormattedMessage
                    defaultMessage="Submit"
                    description={'Mountain Information Network - Form'}
                />
            </Step>
        </ol>
    )
}

function Step({ children, name }) {
    const [state] = Context.useService()
    const { done, context } = state
    const className = clsx(styles.Step, {
        [styles.Active]: state.matches(name),
        [styles.Done]: done || context.completed.has(name),
    })

    return <li className={className}>{children}</li>
}
